import { cn } from '@/lib/utils'

/** Max columns for entity card lists in the main page pane. */
export type PaneResponsiveCardGridMaxColumns = 2 | 3 | 4

/**
 * When the grid steps up to multi-column layout (pane `@container` width).
 * - `pane-wide` — `@2card` / 900px+ (default browse lists)
 * - `pane-compact` — `@2col` / 384px+ on desktop (homepage Featured at default split);
 *   stays 1 column below the `md` viewport (768px) so phones never go 2-up
 * - `fixed-1` — always single column
 */
export type PaneResponsiveCardGridColumnMode = 'pane-wide' | 'pane-compact' | 'fixed-1'

const CARD_GRID_BASE = 'grid w-full grid-cols-1 gap-4'
/** Viewport mobile wins over a still-wide page pane (`@2col` is 384px). */
const COMPACT_MOBILE_ONE_COL = 'max-md:!grid-cols-1'

const WIDE_GRID_MAX_COLUMN_CLASSES: Record<PaneResponsiveCardGridMaxColumns, string> = {
  2: `${CARD_GRID_BASE} @2card:grid-cols-2`,
  3: `${CARD_GRID_BASE} @2card:grid-cols-2 @3card:grid-cols-3`,
  4: `${CARD_GRID_BASE} @2card:grid-cols-2 @3card:grid-cols-3 @4card:grid-cols-4`,
}

const COMPACT_GRID_MAX_COLUMN_CLASSES: Record<PaneResponsiveCardGridMaxColumns, string> = {
  2: `${CARD_GRID_BASE} @2col:grid-cols-2 ${COMPACT_MOBILE_ONE_COL}`,
  3: `${CARD_GRID_BASE} @2col:grid-cols-2 @3col:grid-cols-3 ${COMPACT_MOBILE_ONE_COL}`,
  4: `${CARD_GRID_BASE} @2col:grid-cols-2 @3col:grid-cols-3 @4col:grid-cols-4 ${COMPACT_MOBILE_ONE_COL}`,
}

export function paneResponsiveCardGridClassName(
  maxColumns: PaneResponsiveCardGridMaxColumns,
  className?: string,
  columnMode: PaneResponsiveCardGridColumnMode = 'pane-wide',
) {
  if (columnMode === 'fixed-1') {
    return cn(CARD_GRID_BASE, className)
  }

  const columnClasses =
    columnMode === 'pane-compact'
      ? COMPACT_GRID_MAX_COLUMN_CLASSES[maxColumns]
      : WIDE_GRID_MAX_COLUMN_CLASSES[maxColumns]

  return cn(columnClasses, className)
}
